var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.extData.tenderTermsId
    ? _c(
        "div",
        [
          _vm.allowEdit
            ? _c("HkldDropzone", {
                attrs: {
                  sourceId: _vm.extData.itqTermsId,
                  action: _vm.ActionTypes.settings.doc.itq.create,
                  metaData: { uploadOnTop: true },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("EditTerms", {
            attrs: {
              sourceId: _vm.extData.itqTermsId,
              canEdit: _vm.allowEdit,
              canDelete: _vm.allowEdit,
              canDownloadAll: false,
              action: _vm.ActionTypes.settings.doc.itq.delete,
              updateAction: _vm.ActionTypes.settings.doc.itq.edited,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }